import { createFileRoute } from "@tanstack/react-router";
import { DisciplinesTable } from "@/components/disciplines-table";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/management/disciplines/")({
  component: DisciplinesPage,
});

function DisciplinesPage() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="h-max md:space-y-6 md:px-6">
        <MobilePageTitle className="mt-6">
          {t("pages:discipline.title")}
        </MobilePageTitle>
        <div className="px-6 md:px-0 lg:px-0">
          <DisciplinesTable />
        </div>
      </div>
    </ScrollableContainer>
  );
}
